$("#data-tables thead th").click(function(){
    var col=$(this).index()
    $("#data-tables").sortChildren(function(A,B){
        var a=$(A).find("td").eq(col).text(),
            b=$(B).find("td").eq(col).text();
        return a<b?-1:a>b?+1:0
    },1,0) 
})

 
"use strict"
;(function($){
$.fn.sortChildren=function(cmp,ignoreFirst,ignoreLast){
	return this.each(function(){
		var self=$(this), 
			children=$.makeArray(self.children()),
			first=children.splice(0,ignoreFirst||0),
			last=children.splice(-(ignoreLast||0),ignoreLast)
		self.append(first)
		$.each(children.sort(cmp), function(i, child){
			self.append(child)
		})
		self.append(last)
	})
}
})(jQuery)


$(document).on('click', "#table_scroll_1 th", function () {
	  $('#table_scroll_1 th').not(this).removeClass('active');
      $(this).addClass('active');
}); 

$(document).ready(function() {
  setTimeout(function() {
  $('#table_scroll_1').find('.thbarand_name').trigger('click');
    }, 100);
});